export default function ApplicationLogo(props) {
  return (
    <picture>
      <source srcSet="/images/logo-tiny.webp" type="image/webp" />
      <img src="/images/logo-tiny.png" alt="logo" height={32} width={32} {...props} />
    </picture>
  );
}
